export function getReferrer(): string {
  return document.referrer;
}

export function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

type SessionWindow = typeof window & { hubspot: { sessionId: string | null } };

export function getSessionId(): string | null | undefined {
  return window.hubspot && (window as SessionWindow).hubspot.sessionId;
}
